import React, { Fragment } from 'react'; 
import Header from "../common/header";
import Footer from "../common/footer";
import InvestorBanner from './investor-relations-banner';
import InvestorDescription from './investor-relations-description'; 

function InvestorPage () {
    return(
      <Fragment> 
      <Header />  
      <InvestorBanner /> 
      <InvestorDescription />     
      <Footer /> 
      </Fragment> 
    );
}
export default InvestorPage;